export default {
  title: 'Nouveau variant',
  fields: {
    product: {
      label: 'Produit',
    },
    name: {
      label: 'Nom',
      placeholder: 'Grand',
    },
    price: {
      label: 'Supplément de prix',
    },
  },
  buttons: {
    save: 'Enregistrer',
    close: 'Fermer',
  },
  toasts: {
    variant_got_created: 'Variant créé',
    variant_got_updated: 'Variant mis à jour',
  },
};
